import React from 'react';
import PropTypes from 'prop-types';

import { Currency, Link } from '../../components';
import { TranslatedCopy } from '../../intl/TranslatedCopy';

import { ZERO_DOLLAR_VALUE } from '../../util/constants';

import { selectDepartmentTypes } from '../../types/allotments';
import { ORDER_TYPE_ATONCE, ORDER_TYPE_FUTURES, ORDER_TYPE_FORECAST } from '../constants';
import {
  GA_EVENT_SHOP_AT_ONCE_BUTTON_CLICK,
  GA_EVENT_SHOP_FUTURES_BUTTON_CLICK,
  GA_EVENT_SHOP_FORECAST_BUTTON_CLICK,
  sendEventToGA
} from '../../analytics/constants';

// eslint-disable-next-line
const Department = ({ accountNumber, department, onShopDeptClick, useCurrentContract }) => {
  const noCurrValue = department.currentRemaining ? department.currentRemaining === ZERO_DOLLAR_VALUE : true;
  const noFutureValue = department.currentRemaining ? department.futureRemaining === ZERO_DOLLAR_VALUE : true;
  const currContract = noCurrValue ? '0' : department.currentRemaining;
  let futureContract = noFutureValue ? '0' : department.futureRemaining;
  futureContract = useCurrentContract ? currContract : futureContract;

  const negativeCurrValue = department.currentRemaining && parseFloat(department.currentRemaining) < 0;
  const hasNoUnitAllotments = department.unitAllotments.length === 0;

  const { hasAtOnceCatalogs, hasForecastCatalogs, hasFutureAllotments, hasFuturesCatalogs } = department;

  const isTrue = value => value === 'true' || value === true;

  const hasAtOnceCatas = isTrue(hasAtOnceCatalogs);
  const hasFuturesCatas = isTrue(hasFuturesCatalogs);
  const hasForecastCatas = isTrue(hasForecastCatalogs);

  const hasNoCatalogs = !(hasAtOnceCatas || hasFuturesCatas || hasForecastCatas);

  const handleAtOnceDeptClick = () => {
    onShopDeptClick({ ...department, type: ORDER_TYPE_ATONCE });
    sendEventToGA(GA_EVENT_SHOP_AT_ONCE_BUTTON_CLICK);
  };
  const handleFuturesDeptClick = () => {
    onShopDeptClick({ ...department, type: ORDER_TYPE_FUTURES });
    sendEventToGA(GA_EVENT_SHOP_FUTURES_BUTTON_CLICK);
  };
  const handleForecastDeptClick = () => {
    onShopDeptClick({ ...department, type: ORDER_TYPE_FORECAST });
    sendEventToGA(GA_EVENT_SHOP_FORECAST_BUTTON_CLICK);
  };

  return (
    <div
      className='departmentSelect__item prl4-sm pt5-sm pb5-sm prl0-md pt0-md pb0-md'
      data-desc='departmentSelect__department'
    >
      <div
        className='departmentSelect__name flex-container row start align-center pb4-sm pb0-md pl7-md'
        data-desc='departmentSelect__name'
      >
        <div className='headline-4'>{department.name}</div>
      </div>
      {noCurrValue &&
      noFutureValue &&
      !department.currentBillable &&
      !department.futureBillable &&
      hasNoUnitAllotments &&
      hasNoCatalogs ? (
        <div
          className='departmentSelect__noResults body-3 pt9-md pb9-md pr7-sm ta-sm-c ta-md-r'
          data-desc='departmentSelect__noResults'
        >
          <TranslatedCopy id='shop.deptSelect.table.noResults' />
        </div>
      ) : (
        <div className='departmentSelect__remainingWrap ta-sm-c' data-desc='departmentSelect__results'>
          <div className='departmentSelect__remaining body-3 pl0-sm pr1-sm pt7-md pb7-md prl5-md pr0-md ta-sm-l'>
            <div className='ta-sm-l'>
              <Link
                to={`/shop/${accountNumber}/dept/${department.number}/${ORDER_TYPE_ATONCE}`}
                button
                data-desc='departmentSelect__shop_at_once'
                onClick={handleAtOnceDeptClick}
                disabled={
                  !department.currentBillable &&
                  (noCurrValue || negativeCurrValue) &&
                  hasNoUnitAllotments &&
                  !hasAtOnceCatas
                }
              >
                <TranslatedCopy id='shop.deptSelect.current.button' />
              </Link>
              <div
                className='departmentSelect__currencyContainer pt2-sm pt0-md pl1-sm pl0-md pb2-md pb0-lg pr2-lg'
                data-desc='departmentSelect__current_remaining'
              >
                <Currency value={currContract} type={department.code} /> <TranslatedCopy id='global.remaining' />
              </div>
            </div>
          </div>
          <div className='departmentSelect__remaining body-3 pr0-sm pl1-sm pt7-md pb7-md prl5-md'>
            <div className='ta-sm-l'>
              <Link
                to={`/shop/${accountNumber}/dept/${department.number}/${ORDER_TYPE_FUTURES}`}
                secondaryButton
                data-desc='departmentSelect__shop_future'
                onClick={handleFuturesDeptClick}
                disabled={!hasFutureAllotments || !hasFuturesCatas}
              >
                <TranslatedCopy id='shop.deptSelect.futures.button' />
              </Link>
              <div
                className='departmentSelect__currencyContainer pt2-sm pt0-md pl1-sm pl0-md pb2-md pb0-lg pr2-lg'
                data-desc='departmentSelect__future_remaining'
              >
                <Currency value={futureContract} type={department.code} /> <TranslatedCopy id='global.remaining' />
              </div>
            </div>
          </div>
          <div className='departmentSelect__remaining body-3 prl0-sm pt5-sm pt7-md pb7-md prl5-md'>
            <div className='ta-sm-l'>
              <Link
                to={`/shop/${accountNumber}/dept/${department.number}/${ORDER_TYPE_FORECAST}`}
                secondaryButton
                data-desc='departmentSelect__shop_forecast'
                onClick={handleForecastDeptClick}
                disabled={!hasFutureAllotments || !hasForecastCatas}
                extraClassName='departmentSelect__remaining_link'
              >
                <TranslatedCopy id='shop.deptSelect.forecast.button' />
              </Link>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

Department.propTypes = {
  accountNumber: PropTypes.string.isRequired,
  department: selectDepartmentTypes.isRequired,
  onShopDeptClick: PropTypes.func.isRequired,
  useCurrentContract: PropTypes.bool.isRequired
};

export default Department;
